import React, { Component } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Container, Popover, PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import { Menu, X, Search, Settings, User, HelpCircle, Lock, LogOut } from 'react-feather';
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import { showRightSidebar } from 'service/appconfiguration/action';
import * as FeatherIcon from 'react-feather';
import './index.css';
import { getUserDetails, getScreenPermissionsByRole } from 'service/users/action';
import ProfileDropdown from '../ProfileDropdown';
import LanguageDropdown from '../LanguageDropdown';
import NotificationDropdown from '../NotificationDropdown';
import SettingsDropdown from '../SettingsDropdown';
import UserLogsDropdown from '../UserLogs';
import logo from 'images/logoNoBackground.png';
import profilePic from 'images/users/avatar-7.jpg';
import { logout } from 'service/users/action';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import _find from 'lodash/find';

const UserInfo = () => {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(getUserDetails());
    }, []);
    return null;
};
const UserProfile = ({ props }) => {
    return (
        <React.Fragment>
            <div
                className={
                    parseInt(localStorage.getItem('theme')) ? 'media user-profile top-bar-dark ' : 'media user-profile top-bar-light'
                }
            >
                {/* <img src={profilePic} className="avatar-sm rounded-circle mr-2 mb-1" alt="Recon" /> */}
                {/* <img src={profilePic} className="avatar-xs rounded-circle mr-2" alt="Recon" /> */}

                <div className="media-body for-position-credits">
                    <h6 style={{ marginLeft: '-55px', textAlign: 'center' }} className="pro-user-name mt-2 mb-0">
                        {props.user.displayname}
                    </h6>
                    {/* <span className="pro-user-desc">Administrator</span> */}
                </div>

                <UncontrolledDropdown className="align-self-center profile-dropdown-menu">
                    <DropdownToggle data-toggle="dropdown" tag="button" className="btn btn-link p-0 dropdown-toggle mr-0">
                        <FeatherIcon.ChevronDown />
                    </DropdownToggle>
                    <DropdownMenu right className="topbar-dropdown-menu profile-dropdown-items">
                        <Link to="/" className="dropdown-item notify-item">
                            <FeatherIcon.User className="icon-dual icon-xs mr-2" />
                            <span>My Account</span>
                        </Link>
                        <Link to="/" className="dropdown-item notify-item">
                            <FeatherIcon.Settings className="icon-dual icon-xs mr-2" />
                            <span>Settings</span>
                        </Link>
                        <Link to="/" className="dropdown-item notify-item">
                            <FeatherIcon.HelpCircle className="icon-dual icon-xs mr-2" />
                            <span>Support</span>
                        </Link>
                        <Link to="/" className="dropdown-item notify-item">
                            <FeatherIcon.Lock className="icon-dual icon-xs mr-2" />
                            <span>Lock Screen</span>
                        </Link>
                        <DropdownItem divider />
                        <Link to="/account/login" onClick={() => logout()} className="dropdown-item notify-item">
                            <FeatherIcon.LogOut className="icon-dual icon-xs mr-2" />
                            <span>Logout</span>
                        </Link>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>
        </React.Fragment>
    );
};

const Notifications = [
    {
        id: 1,
        text: 'New user registered',
        subText: '1 min ago',
        icon: 'uil uil-user-plus',
        bgColor: 'primary',
    },
    {
        id: 2,
        text: 'Karen Robinson',
        subText: 'Wow ! this admin looks good and awesome design',
        icon: 'uil uil-comment-message',
        bgColor: 'success',
    },
    {
        id: 3,
        text: 'Cristina Pride',
        subText: 'Hi, How are you? What about our next meeting',
        icon: 'uil uil-comment-message',
        bgColor: 'danger',
    },
    {
        id: 4,
        text: 'New user registered',
        subText: '1 day ago',
        icon: 'uil uil-user-plus',
        bgColor: 'info',
    },
];

const ProfileMenus = [
    {
        label: 'My Account',
        icon: User,
        redirectTo: '/',
    },
    {
        label: 'Settings',
        icon: Settings,
        redirectTo: '/',
    },
    {
        label: 'Support',
        icon: HelpCircle,
        redirectTo: '/',
    },
    {
        label: 'Lock Screen',
        icon: Lock,
        redirectTo: '/',
    },
    {
        label: 'Logout',
        icon: LogOut,
        redirectTo: '/account/login',
        hasDivider: true,
    },
];

class Topbar extends Component {
    constructor(props) {
        super(props);
        this.handleRightSideBar = this.handleRightSideBar.bind(this);
        this.state = {
            language: 0,
            theme: parseInt(localStorage.getItem('theme')),
        };
        this.props.getScreenPermissionsByRole('/entitlement/user-logs');
    }
    /**
     * Toggles the right sidebar
     */
    handleRightSideBar = () => {
        this.props.showRightSidebar();
    };
    handleLangChange = (event) => {
        if (event.target.checked == true) {
            this.setState({ theme: 1 });
            localStorage.setItem('theme', 1);
            location.reload();
        } else {
            this.setState({ theme: 0 });
            localStorage.setItem('theme', 0);
            location.reload();
        }
    };
    render() {
        const username = localStorage.getItem('username');
        const isTradeUser = username === 'ta1user@ta.com' || username === 'ta2user@ta.com' || username === 'citiuser@citi.com';
        const isLogsEnabled = _get(
            _find(this.props.screenPermissions, (col) => col.title === 'Enable User Logins'),
            'isActionEnabled',
            null,
        );
        return (
            <React.Fragment>
                <UserInfo />
                <div className="navbar navbar-expand flex-column flex-md-row navbar-custom">
                    <Container fluid>
                        {/* logo */}
                        <Link to="/" className="navbar-brand mr-0 mr-md-2 logo topbar-text-width">
                            <span className="logo-lg">
                                <img src={logo} alt="" height="24" className="forTheImage ml-1" />
                                <span className="topbar-text-width">
                                    <span className="d-inline h5 ml-3 text-logo1">BlocData</span>
                                </span>
                            </span>
                        </Link>
                        <ul className="navbar-nav flex-row   list-unstyled topnav-menu mb-0" style={{ marginLeft: '50px' }}>
                            {/* <div className="app-search">
                                <form>
                                    <div className="input-group">
                                        <input type="text" className="form-control" placeholder="Search..." />
                                        <Search />
                                    </div>
                                </form>
                            </div>
                            <LanguageDropdown tag="li" />
                            <NotificationDropdown notifications={Notifications} /> */}
                        </ul>
                        {/* menu*/}
                        <ul className="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0">
                            <li className="">
                                <button className="button-menu-mobile open-left disable-btn" onClick={this.props.openLeftMenuCallBack}>
                                    <Menu className="menu-icon" />
                                    <X className="close-icon" />
                                </button>
                            </li>
                        </ul>
                        <ul className="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">
                            {isLogsEnabled && <UserLogsDropdown />}
                            <SettingsDropdown />
                            {/* <NotificationDropdown notifications={[{text:'title',subText:'content'}]}/> */}
                            {/* <li className="d-none d-sm-block"> */}
                            {/* <div className="app-search">
                                    <form>
                                        <div className="input-group">
                                            <input type="text" className="form-control" placeholder="Search..." />
                                            <Search />
                                        </div>
                                    </form>
                                </div> */}
                            {/* </li> */}
                            <UserProfile props={this.props} />
                            <ProfileDropdown
                                profilePic={profilePic}
                                menuItems={ProfileMenus}
                                username={'Recon N'}
                                description="Administrator"
                            />
                        </ul>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        projectStatus: state.projectReducer,
        user: state.usersReducer.userDetails,
        screenPermissions: state.usersReducer.screenPermissions,
    };
};

export default connect(mapStateToProps, { showRightSidebar, getScreenPermissionsByRole })(Topbar);
